import CustomTable, { ICustomTableColumn } from '../Table';
import SkeletonLoader from './index';

interface ITeacherReportSkeletonProps<T extends object> {
  columns: ICustomTableColumn<T>[];
}

const TeacherReportSkeleton = <T extends object>({
  columns,
}: ITeacherReportSkeletonProps<T>) => {
  return (
    <div className="flex flex-col gap-6">
      {/* Filters Header - Matches real header structure */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        {/* Left section: Search, Class Select, Lesson Select */}
        <div className="flex flex-1 items-center gap-3 flex-wrap">
          {/* Search Input Skeleton */}
          <SkeletonLoader className="h-11 w-70 rounded-lg" variant="rect" />

          {/* Class Select Skeleton */}
          <SkeletonLoader className="h-12 w-37.5 rounded-lg" variant="rect" />

          {/* Lesson Select Skeleton */}
          <SkeletonLoader className="h-12 w-37.5 rounded-lg" variant="rect" />
        </div>

        {/* Right section: DatePicker, Export Button */}
        <div className="flex items-center gap-3">
          {/* DateRangePicker Skeleton */}
          <SkeletonLoader className="h-12 w-48 rounded-lg" variant="rect" />

          {/* Export Button Skeleton */}
          <SkeletonLoader className="h-12 w-40 rounded-lg" variant="rect" />
        </div>
      </div>

      {/* Table Skeleton via CustomTable */}
      <CustomTable columns={columns} dataSource={[]} isLoading={true} />
    </div>
  );
};

export default TeacherReportSkeleton;
